export function Field({ label, children, testid, error }) {
  return (
    <div className="flex flex-col gap-2" data-testid={testid}>
      <label className={`overline transition-colors ${error ? "text-red-400" : "text-white/50"}`}>{label}</label>
      {children}
    </div>
  );
}

const base =
  "bg-transparent border-b pb-2 text-white placeholder-white/35 focus:outline-none transition-colors w-full rounded-none text-base";
const okBorder = "border-white/20 focus:border-[#C5A059]";
const errBorder = "border-red-500 focus:border-red-500";

export function Text({ testid, error, ...props }) {
  return <input data-testid={testid} className={`${base} ${error ? errBorder : okBorder}`} {...props} />;
}

export function Area({ testid, error, ...props }) {
  return <textarea data-testid={testid} rows={3} className={`${base} resize-none ${error ? errBorder : okBorder}`} {...props} />;
}

export function Select({ testid, options, placeholder = "Select…", error, ...props }) {
  return (
    <select
      data-testid={testid}
      className={`${base} appearance-none cursor-pointer [&>option]:bg-[#1A1A1A] [&>option]:text-white ${error ? errBorder : okBorder}`}
      {...props}
    >
      <option value="" disabled>{placeholder}</option>
      {options.map((o) => {
        const val = typeof o === "string" ? o : o.value;
        const lab = typeof o === "string" ? o : o.label;
        return <option key={val} value={val}>{lab}</option>;
      })}
    </select>
  );
}

export function Check({ testid, label, ...props }) {
  return (
    <label className="flex items-center gap-3 cursor-pointer text-white/80 text-sm" data-testid={testid}>
      <input type="checkbox" className="accent-[#C5A059] h-4 w-4" {...props} />
      {label}
    </label>
  );
}
